// extracted by mini-css-extract-plugin
export default {"mainContainer":"signup_mainContainer__1ChUk","formContainer":"signup_formContainer__2N9Pz","formInput":"signup_formInput__YZy6v"};